import { cva } from 'class-variance-authority';

export { default as NavigationMenu } from './NavigationMenu.vue';
export { default as NavigationMenuContent } from './NavigationMenuContent.vue';
export { default as NavigationMenuItem } from './NavigationMenuItem.vue';
export { default as NavigationMenuLink } from './NavigationMenuLink.vue';
export { default as NavigationMenuList } from './NavigationMenuList.vue';
export { default as NavigationMenuTrigger } from './NavigationMenuTrigger.vue';
export { default as NavigationMenuViewport } from './NavigationMenuViewport.vue';

export const navigationMenuTriggerStyle = cva(
	'group relative inline-flex h-full w-max items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition-colors after:absolute after:bottom-0 after:w-0 after:transition-["width"] after:content-[""] hover:after:w-full hover:after:border-b-2 hover:after:border-b-beige  focus:text-accent-foreground cursor-pointer focus:outline-none disabled:pointer-events-none disabled:opacity-50 '
);
